import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import React from "react";

const styles = (theme: Theme) =>
  createStyles({
    labelSuffix: {
      color: theme.palette.text.hint,
      fontStyle: "italic",
    },
  });

interface LabelProps extends WithStyles<typeof styles> {
  fieldId?: string;
  required?: boolean;
  label: string;
  labelOnly?: boolean;
  shrinkLabel?: boolean;
  formLabel?: boolean;
  allowHtml?: boolean;
}

export const LabelComponent = (props: LabelProps) => {
  const { fieldId, required, labelOnly, shrinkLabel, formLabel, allowHtml, classes } = props;
  if (!props.label) {
    return null;
  }

  const label = allowHtml ? <span dangerouslySetInnerHTML={{ __html: props.label }} /> : props.label;

  return formLabel ? (
    <FormLabel>
      {labelOnly ? (
        label
      ) : required ? (
        label
      ) : (
        <span>
          {label} <span className={classes.labelSuffix}>(Optional)</span>
        </span>
      )}
    </FormLabel>
  ) : (
    <InputLabel htmlFor={fieldId} shrink={labelOnly || shrinkLabel ? true : undefined}>
      {labelOnly ? (
        label
      ) : required ? (
        label
      ) : (
        <span>
          {label} <span className={classes.labelSuffix}>(Optional)</span>
        </span>
      )}
    </InputLabel>
  );
};

export const Label = withStyles(styles)(LabelComponent);
